module.exports = __webpack_public_path__ + "img/ch70.a44b86bb.png";